import * as React from 'react';
const SvgDesktop = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 4a2.5 2.5 0 012.5-2.5h13A2.5 2.5 0 0119 4v7.5a2.5 2.5 0 01-2.5 2.5H14v2.1c0 .22.186.393.39.479A1 1 0 0114 18.5H6a1 1 0 01-.39-1.921c.204-.086.39-.258.39-.479V14H3.5A2.5 2.5 0 011 11.5V4zm16 8V3.5H3V12h14zm-9 2v2.5h4V14H8z"
            fill="currentColor"
        />
    </svg>
);
export default SvgDesktop;
